import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserDevice } from '../models/user-device.model';
import { map } from 'rxjs';

import { BaseService } from './_base.service';

@Injectable()
export class UserDeviceService extends BaseService {

  index() {
    return this.http.get<UserDevice[]>(`${this.apiURL}/user_devices`, this.getParams())
      .pipe(
        map((response: HttpResponse<UserDevice[]>) => response.body),
      );
  }

  update(userDevice: Partial<UserDevice>) {
    return this.http.put(`${this.apiURL}/user_devices`, { user_device: userDevice }, this.getParams())
      .pipe(
        map((response: HttpResponse<UserDevice[]>) => response.body),
      );
  }

  destroy(id: number) {
    return this.http.delete(`${this.apiURL}/user_devices/${id}`, this.getParams())
      .pipe(
        map((response: HttpResponse<UserDevice[]>) => response.body),
      );
  }
}
